const dF = "YYYY-MM-DD";

import Vue from "vue";
import store from "../store";
import { rFlight } from "@/modules/form";

import Vuex, { mapActions } from "vuex";
import { getField, updateField } from "vuex-map-fields";
import { createHelpers } from "vuex-map-fields";
const { mapFields } = createHelpers({
  getterType: "getField",
  mutationType: "updateField"
});
Vue.use(Vuex);

import shared from "@/mixins/Shared";
import LocationSelect from "@/components/forms/sections/LocationSelect.vue";
import DateSelect from "@/components/forms/sections/DateSelect.vue";
import DepartureDateSelect from "@/components/forms/sections/DepartureDateSelect.vue";
import PassengerSelect from "@/components/forms/sections/PassengerSelect.vue";
import AddPassengerDetails from "@/components/forms/sections/AddPassengerDetails.vue";
import FlightSummary from "@/components/pages/FlightSummary.vue";
import User from "@/components/forms/sections/User.vue";
import Payment from "@/components/forms/sections/PaymentForm.vue";
import dayjs from "dayjs";
// import { isNumber } from "util";

const mixins = {
  methods: {
    getFormSteps() {
      if (this.form_fields.ret_date === null) {
        let steps = [];
        for (let x = 0; x < this.form[0].children.length; x++) {
          let s = this.form[0].children[x];
          if (s.name !== "Return") {
            if (steps.find(step => step.name === s.name) === undefined) {
              steps.push(s);
            }
          }
        }
        return steps;
      } else {
        return this.form[0].children;
      }
    },
    removeReturnFlight() {
      let nF = [];
      let forms = store.state.form[0].children;
      if (this.form_fields.ret_date === null) {
        store.commit("disableForm", "Return");
      }
    },
    addReturnFlight() {
      let nF = [];
      if (this.form_fields.ret_date !== null) {
        store.commit("enableForm", "Return");
        if (this.addReturnFlight === null) {
          store.commit("setStepIncomplete", "Return");
        }
        store.commit("setRoundTrip", true);
      }
    }
  }
};

const actions = {};

export default {
  name: "BookingFormMixin",
  computed: {
    ...mapFields([
      "complete",
      "editMode",
      "mobileDevice",
      "form",
      "steps",
      "locations",
      "form_fields",
      "form_fields.b_id",
      "form_fields.dep_loc",
      "form_fields.dest_loc",
      "form_fields.dep_date",
      "form_fields.ret_date",
      "form_fields.pax_a",
      "form_fields.pax_c",
      "form_fields.pax_i",
      "departFlight",
      "returnFlight",
      "samepassengers",
      "loading",
      "loading2",
      "editBookingData"
    ])
  },
  data: () => ({
    store: store,
    today: dayjs(new Date()).format(dF),
    disabledDates: date => {
      var tDay = new Date(date);
      var yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
      return tDay.getTime() < yesterday.getTime();
    },
    disabledDatesReturn: date => {
      var tDay = dayjs(date).unix();
      var cDay = dayjs(this.getDepartDate).unix();
      return tDay < cDay;
    },
    destLocations: null,
    previousDest: 0,
    previousDepart: 0
  }),
  actions: actions,
  components: {
    LocationSelect,
    PassengerSelect,
    DateSelect,
    DepartureDateSelect,
    AddPassengerDetails,
    FlightSummary,
    User,
    Payment
  },
  mixins: [shared, mixins],
  methods: {
    ...mapActions(["RESET_DEPART_FLIGHTS", "RESET_RETURN_FLIGHTS"])
  },
  watch: {
    complete: function() {
      if (this.complete === true) {
        this.goToPath("/booking/complete");
      } else {
        this.goToPath("/");
      }
    },
    samepassengers: function() {
      if (this.loading !== true) {
        const index = this.getFormIndexByPath(this.$route.path);
        if (
          this.returnFlight !== null &&
          this.editMode !== true
        ) {
          const oPax = this.returnFlight.passengers;
          this.resetReturnFlight();
          store.dispatch("UNSET_ERRORS", "Returning Passengers");
          this.loadPassengerFields(oPax);
          this.completeSection("Returning Passengers");
          store.commit("resetLineItems");
          store.commit("setStepIncomplete", "Passengers");
          this.setNextStepQuery(index);
        }
      }
    },
    "form_fields.dep_loc": function(val) {
      if (this.editMode !== true) {
        if (
          this.loading !== true &&
          val !== this.previousDepart
        ) {
          this.previousDepart = val;
        } else {
          return;
        }
        this.resetReturnFlight();
        store.dispatch("RESET_DEPART_FLIGHTS");
        if (
          this.form_fields.dep_loc < 1 ||
          this.form_fields.dest_loc < 1
        ) {
          store.commit("setStepIncomplete", "Locations");
          store.commit("resetLineItems");
				}
				this.reloadFlightSearch();
      }
    },
    "form_fields.dest_loc": function(val) {
      if (
        this.loading !== true &&
        val !== this.previousDest
      ) {
        this.previousDest = val;
      } else {
        return;
      }
      const index = this.getFormIndexByPath(this.$route.path);
      if (val * 1 >= 1) {
        if (
          this.dep_loc * 1 >= 1 &&
          index === 0
        ) {
          if (
            this.departFlight !== null &&
            this.editMode !== true
          ) {
            store.dispatch("RESET_DEPART_FLIGHTS");
          }
          if (
            this.form_fields.round_trip === false &&
            this.editMode !== true
          ) {
            this.resetReturnFlight();
          }
          store.dispatch("UNSET_ERRORS", "Locations");
          this.completeSection("Locations");
          if (
            this.dest_loc > 0 &&
            this.dep_loc > 0 &&
            this.editMode !== true
          ) {
              this.setNextStepQuery(index);
              return;
          }
        }
      } else {
        store.commit("setStepIncomplete", "Locations");
        store.commit("resetLineItems");
      }
    },
    "form_fields.dep_date": function(val) {
      if (this.editMode !== true) {
        const index = this.getFormIndexByPath(this.$route.path);
        if (
          this.$route.query === undefined &&
          val !== this.previousDepart
        ) {
          this.previousDepart = val;
        }
        let dep = dayjs(val);
        if (this.form_fields.ret_date !== null) {
          let ret = dayjs(this.form_fields.ret_date);
          if (ret.isBefore(dep)) {
            store.commit("setRetDate", val);
            store.commit("resetReturnFlight");
            store.commit("setStepIncomplete", "Returning");
            store.commit("resetLineItems");
          }
        }
        const test = this.testDates(val, this.form_fields.ret_date);
        if (
          this.form_fields.ret_date !== null &&
          this.editMode !== true
        ) {
          store.commit("resetDepartFlight");
          store.commit("setStepIncomplete", "Departing");
          store.commit("resetLineItems");
        } else {

        }
        if (
          index === 0 ||
          index === 1
        ) {
          if (test === true) {
            store.dispatch("UNSET_ERRORS", "Dates");
            store.dispatch("RESET_DEPART_FLIGHTS");
            if (this.form_fields.ret_date !== null) {
              this.addReturnFlight();
            }
            this.setNextStepQuery(index);
          } else {
            this.setError(test[0], test[1]);
            return;
          }
        }
      }
    },
    "form_fields.ret_date": function(val) {
      if (
        this.editMode !== true &&
        this.$route.query.round_trip === undefined
      ) {
        const index = this.getFormIndexByPath(this.$route.path);
        const test = this.testDates(this.form_fields.dep_date, val);
        if (val !== null) {
          if (test === true) {
            store.dispatch("UNSET_ERRORS", "Dates");
            this.addReturnFlight();
            this.completeSection("Dates");
            if (index === 1) {
              this.selectDate(val);
              this.setNextStepQuery(index);
            }
          } else {
            this.setError(test[0], test[1]);
          }
        } else if (test === true) {
          store.dispatch("UNSET_ERRORS", "Dates");
        }
      }
    }
  }
};
